<!-- compliance-exemption-card.component.html -->
<mat-card *ngIf="isAdmin" class="cec" [class.cec--alternate]="alternateStyle">
  <mat-card-title class="cec__title"><mat-icon>verified_user</mat-icon> Trial / Subscription</mat-card-title>
  <mat-card-content *ngIf="!loading; else spin">
    <div *ngIf="trialEnded" class="cec__ended" role="alert">
      <mat-icon>hourglass_bottom</mat-icon>
      <div>
        <strong>Trial ended on {{ endedOnDate | date:'dd MMM yyyy' }}.</strong>
        Turn the requirements back on (the company's users will be notified), or extend the trial below.
        <div class="cec__restore">
          <mat-checkbox [(ngModel)]="restore.terms" [disabled]="!savedSkipTerms">Terms &amp; Conditions</mat-checkbox>
          <mat-checkbox [(ngModel)]="restore.kyc" [disabled]="!savedSkipKyc">KYC</mat-checkbox>
          <button mat-flat-button color="primary" (click)="restoreGates()" [disabled]="saving || (!restore.terms && !restore.kyc)">Turn back on</button>
        </div>
      </div>
    </div>

    <p class="cec__state">
      Status:
      <strong *ngIf="active">{{ form.planType === 'TRIAL' ? 'Trial' : 'Subscription' }} active</strong>
      <strong *ngIf="!active">No exemption: Terms &amp; Conditions and KYC apply</strong>
    </p>

    <div class="cec__grid">
      <mat-form-field appearance="outline">
        <mat-label>Plan</mat-label>
        <mat-select [(ngModel)]="form.planType" (selectionChange)="onPlanChange()">
          <mat-option value="TRIAL">Trial</mat-option>
          <mat-option value="SUBSCRIPTION">Subscription</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ form.planType === 'TRIAL' ? 'Trial ends on' : 'Ends on (optional)' }}</mat-label>
        <input matInput [matDatepicker]="cecPicker" [(ngModel)]="form.endsAt" [min]="minDate" [max]="form.planType === 'TRIAL' ? maxDate : null" [required]="form.planType === 'TRIAL'">
        <mat-datepicker-toggle matSuffix [for]="cecPicker"></mat-datepicker-toggle>
        <mat-datepicker #cecPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <mat-slide-toggle [(ngModel)]="form.skipTerms">Skip Terms &amp; Conditions</mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="form.skipKyc" class="cec__toggle">Skip KYC</mat-slide-toggle>
    <mat-form-field appearance="outline" class="cec__note">
      <mat-label>Note</mat-label>
      <input matInput [(ngModel)]="form.note" maxlength="500">
    </mat-form-field>

    <div class="cec__actions">
      <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || (form.planType === 'TRIAL' && !form.endsAt)">Save</button>
      <button mat-stroked-button color="warn" (click)="turnOff()" [disabled]="saving || !active">Turn off</button>
    </div>

    <div *ngIf="data?.history?.length" class="cec__history">
      <div class="cec__history-title">History</div>
      <div *ngFor="let h of data.history" class="cec__history-row">
        <span>{{ h.createdAt | date:'dd MMM yyyy, HH:mm' }}</span>
        <span>{{ h.action }}</span>
        <span>{{ h.actorName || 'System' }}</span>
      </div>
    </div>
  </mat-card-content>
  <ng-template #spin><mat-spinner diameter="28"></mat-spinner></ng-template>
</mat-card>
